<div mat-dialog-content>
    <kiene-gruppe-details
        style="margin: 24px; height: 100%"
        [gruppe]="gruppe"
        [auswahl]="auswahl"
        [identifikation]="identifikation"
        [identifikationText]="identifikationText"
    ></kiene-gruppe-details>
</div>
<div mat-dialog-actions>
    <span class="spacer"></span>
    <button mat-button (click)="close()">Schlie&szlig;en</button>
</div>
